// extracted by mini-css-extract-plugin
export default {"invoice":"W1vFo9IDicukqfwdR4TY","current":"XaiHpZPDnZRhEAr7ycE8","invalid":"T_XQi5F9DkhZsnz9e90L","modal":"zLZ8RAXElrD3_fJBjSMs"};